<template>
    <section class="section-credentials section-white">
        <h2 class="text-green">
            Bestiller og reisedeltaker:
        </h2>
        <h3>Fyll ut din informasjon:</h3>

        <div class="split pb-1">
            <h4 class="col1">Fornavn: <span>*</span></h4>
            <div class="col2">
                <input class="input" v-model="form.firstName" name="firstName" @blur="$v.form.firstName.$touch" placeholder="Fornavn, slik det står i passet"/>
            </div>
            <div></div>
            <div class="input-error" v-if="!$v.form.firstName.required && $v.form.firstName.$dirty">Du må fylle ut fornavn</div>
        </div>

        <div class="split pb-1">
            <h4 class="col1">Etternavn: <span>*</span></h4>
            <div class="col2">
                <input class="input" v-model="form.lastName" name="lastName" @blur="$v.form.lastName.$touch" placeholder="Etternavn, slik det står i passet"/>
            </div>
            <div></div>
            <div class="input-error" v-if="!$v.form.lastName.required  && $v.form.lastName.$dirty">Du må fylle inn etternavn</div>
        </div>


        <div class="split pb-1">
            <h4 class="col1">Fødselsdag: <span>*</span></h4>
            <div class="col2">
                <date-selector v-model="form.birthday" @invalid-input="$v.form.birthday.$touch"/>
            </div>
            <div></div>
            <div class="input-error" v-if="!$v.form.birthday.mustBeDate && $v.form.birthday.$dirty">Du må fylle inn fødselsdag</div>
        </div>

        <div class="split pb-1">
            <h4 class="col1">Kjønn: <span>*</span></h4>
            <div class="col2" @click="$v.form.gender.$touch">
                <div class="custom-radio">
                    <input type="radio" id="gender-male-customer" v-model="form.gender" name="gender" value="male"/>
                    <label for="gender-male-customer">
                        Mann
                    </label>
                </div>
                <div class="custom-radio">
                    <input type="radio" id="gender-female-customer" v-model="form.gender" name="gender" value="female"/>
                    <label for="gender-female-customer">
                        Kvinne
                    </label>
                </div>
            </div>
            <div></div>
            <div class="input-error" v-if="!$v.form.gender.required && $v.form.gender.$dirty">Du må fylle ut kjønn</div>
        </div>
        <div>
            <div class="split pb-1">
                <h4 class="col1">Mobil: <span>*</span></h4>
                <div class="col2">
                    <input class="input" v-model="form.mobile"
                           type="tel"
                           @blur="$v.form.mobile.$touch"
                           name="phone"
                           placeholder="Mobilnummer (Fasttelefon, dersom du ikke har mobil)"/>
                </div>
                <div></div>
                <div class="input-error" v-if="!$v.form.mobile.required && $v.form.mobile.$dirty">Du må fylle ut mobilnummer</div>
            </div>

            <div class="split pb-1">
                <h4 class="col1">E-post: <span>*</span></h4>
                <div class="col2">
                    <input class="input" v-model="form.email" @blur="$v.form.email.$touch" type="email" name="email" placeholder="E-postadresse"/>
                </div>
                <div></div>
                <div class="input-error" v-if="$v.form.email.$error && $v.form.email.$dirty">Du må fylle ut en gyldig e-post adresse</div>
            </div>

            <div class="split pb-1">
                <h4 class="col1">Post/gateadresse: <span>*</span></h4>
                <div class="col2">
                    <input class="input" v-model="form.streetAddress" @blur="$v.form.streetAddress.$touch" name="streetAddress" placeholder="Post- eller gateadresse"/>
                </div>
                <div></div>
                <div class="input-error" v-if="!$v.form.streetAddress.required  && $v.form.streetAddress.$dirty">Du må fylle ut postadresse</div>
            </div>

            <div class="split pb-1">
                <h4 class="col1">Postnummer: <span>*</span></h4>
                <div class="col2">
                    <input class="input" type="number" v-model="form.zip" @blur="$v.form.zip.$touch" name="zip" placeholder="Postnummer"/>
                </div>
                <div></div>
                <div class="input-error" v-if="!$v.form.zip.required  && $v.form.zip.$dirty">Du må fylle ut postnummer</div>
            </div>

            <div class="split pb-1">
                <h4 class="col1">By/sted: <span>*</span></h4>
                <div class="col2">
                    <input class="input" v-model="form.city" @blur="$v.form.city.$touch" name="city" placeholder="By eller sted"/>
                </div>
                <div></div>
                <div class="input-error" v-if="!$v.form.city.required  && $v.form.city.$dirty">Du må fylle ut sted</div>
            </div>
        </div>
    </section>
</template>

<script>
    import Dropdown from "./Dropdown";
    import Radio from "./Radio";
    import DateSelector from "./DateSelector";
    import {required, email} from 'vuelidate/lib/validators'
    import {mustBeDate} from "./validators";

    export default {
        name: 'CustomerForm',

        components: {
            Dropdown,
            Radio,
            DateSelector,
        },
        props: {
            customer: {
                required: true,
            },
            showErrors: {
                required: false,
                default: false,
            }
        },
        data() {
            return {
                date: {
                    day: null,
                    month: null,
                    year: null
                },
                form: {
                    firstName: null,
                    lastName: null,
                    birthday: null,
                    gender: null,
                    mobile: null,
                    email: null,
                    streetAddress: null,
                    zip: null,
                    city: null,
                }
            };
        },
        validations: {
            form: {
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                birthday: {
                    required,
                    mustBeDate
                },
                gender: {
                    required
                },
                mobile: {
                    required
                },
                email: {
                    required,
                    email,
                },
                streetAddress: {
                    required
                },
                zip: {
                    required,
                },
                city: {
                    required
                },
            }
        },

        watch: {

            form: {
                deep: true,
                handler(newVal) {
                    this.$emit('updated', newVal)
                }
            },
            customer: {
                deep: true,
                handler(newVal) {
                    this.form = newVal
                }
            },
            showErrors() {
                this.$v.$touch();
            }
        },
        created() {
            if (this.customer != null) {
                this.form = this.customer;
            }
        }
    }
</script>
